import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import store from '@/store'
import { API_BASE } from '@/config'

// 统一 axios 实例：FastAdmin 标准返回 { code, msg, data }
// baseURL 固定写死后端地址（见 src/config/index.js），前后端分离直连，不走代理
const service = axios.create({
  baseURL: API_BASE,
  timeout: 15000
})

// 请求拦截：附加 token（后端从 Token header 读取）
service.interceptors.request.use(config => {
  const token = store.state.token || localStorage.getItem('crm_token')
  if (token) config.headers['Token'] = token
  return config
})

// 响应拦截：统一处理业务码
service.interceptors.response.use(
  response => {
    const { code, msg, data } = response.data || {}
    if (code === 1) return data

    if (code === 401) {
      // 登录态失效：清空并跳登录页
      store.commit('clearAuth')
      if (router.currentRoute.path !== '/login') {
        Message.error(msg || '登录已失效，请重新登录')
        router.push('/login')
      }
      return Promise.reject(new Error(msg || '登录已失效'))
    }

    Message.error(msg || '操作失败')
    return Promise.reject(new Error(msg || '操作失败'))
  },
  error => {
    const status = error.response && error.response.status
    const errData = error.response && error.response.data
    // 后端登录失效返回 HTTP 401（$this->error(msg, null, 401)），axios 走 error 分支：
    // 清空登录态并跳转登录页
    if (status === 401) {
      store.commit('clearAuth')
      if (router.currentRoute.path !== '/login') {
        Message.error((errData && errData.msg) || '登录已失效，请重新登录')
        router.push('/login')
      }
      return Promise.reject(error)
    }
    Message.error((errData && errData.msg) || error.message || '网络异常')
    return Promise.reject(error)
  }
)

export default service
